import React, {useCallback} from 'react';
import {useStoreActions, useStoreState} from "easy-peasy";

const BackButton = ({questionIndex}) => {
    const goto       = useStoreActions(actions => actions.path.goto);
    const goBack     = useStoreActions(actions => actions.question.goBack);
    const goBackAnim = useStoreActions(actions => actions.animation.goBack);

    const answers = useStoreState(actions => actions.answers.current);

    const onClick = useCallback(() => {
        if (questionIndex > 1) {
            window.dataLayer.push(`${answers[0]}_BackToQ${questionIndex - 1}`);
            goBackAnim();
            goBack();
            goto(`/q${questionIndex - 1}`);
        }
        document.querySelector(`.back-button`).blur();
        document.querySelector(`.options-container`).firstChild.focus();
    }, [goto, questionIndex, goBack, goBackAnim, answers]);

    return (
        <section role="button" className="back-button" onClick={onClick} tabIndex="0"
            onKeyDown={event => {
                if (event.keyCode === 13) {
                    onClick();
                } else if (event.keyCode === 32) {
                    onClick();
                }
            }}>
            <img src={`/images/back-arrow.svg`} alt={`Go back a question`}/>
            <p>Back</p>
        </section>
    );
};

export default BackButton;
